export function isNonRetryableScreenShareError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? '')
  const name = error instanceof Error ? error.name : ''

  return (
    name === 'NotAllowedError' ||
    name === 'AbortError' ||
    name === 'NotSupportedError' ||
    /cancelled|cancel|dismissed|denied|not allowed|getdisplaymedia is not supported|not supported/i.test(message)
  )
}
